// descomentar apenas para apps Laravel (fullstack)
// (nesse arquivo o token CSRF eh inserido nos headers padrao do axios)
require('./bootstrap');

/**
 * Arquivo JavaScript principal.
 * A partir daqui são incluídas todas as dependências.
 */

import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import Pbh from '@prodabel/piweb-lib-vue';

import router from './routes';
import store from './stores';
import * as helpers from './helpers';
import filters from './filters';
import Axios from "axios";
import keycloakvue from '@prodabel/vue-keycloak-adapter';

import UsuarioAutenticadoLayout from './components/UsuarioAutenticadoLayout.vue';

const redirectUri = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_BASE_URL}`;

const options = {
    onLoad: 'login-required',
    redirectUri
};

const permissions = {    
    "guest": [],
    "logged": ["USC.12.282", "inicio"],
    "any": ["403", "404"]
}

const authErrorCallback = function(error){
    try {
        const erro = JSON.parse(error.message);
        alert(JSON.stringify(erro))
        if (erro.response.status == 403){
            alert('Acesso negado.');
            // router.go({name: '403'});
            console.log('Auth Original:', error);
        } else {
            alert('Erro inesperado.');
            console.log('Original:', error);
        }
    } catch (e){
        console.log('Erro ao tratar o erro');
        console.log('Original:', error);
        console.log('Secundário: ', e);
    }
}
Vue.use(keycloakvue, { store, router, options, authErrorCallback, authorize_disabled: true, permissions, optionsConst: `${redirectUri}keycloak.json` })

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Axios.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${store.getters.token}`;
    return config;
});

Vue.prototype.$axios = Axios;


Vue.use(Pbh, {
    merge: {
        filters,
        helpers
    }
});

// descomentar a linha abaixo para habilitar o login
// Vue.use(keycloak, {router, store, verbose: true});

Vue.filter('formatReais', function (value) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(value);
});

Vue.filter('formatDate', filters.formatDate);
Vue.filter('formatDateTime', filters.formatDateTime);
Vue.filter('formatIndiceCadastral', filters.formatIndiceCadastral);
Vue.filter('formatLancamento', filters.formatLancamento);
Vue.filter('formatCurrency', filters.formatCurrency);
Vue.filter('formatCPFCNPJ', filters.formatCPFCNPJ);

helpers.getEnv().then(env => { 
    Vue.prototype.$env = env;
    window.envJson = env;    

    Vue.prototype.$http = Axios.create({
        baseURL: env.url_backend,
    });

    new Vue({
        data() {
            return {
                carregando: false,
            }
        },
        store,
        router,
        render: h => h(UsuarioAutenticadoLayout),
    }).$mount('#app')
});